//引入
import request from "../utils/request";
import wyqyId from "../config";
const api = {
  //物业企业详情
  wyqyinfo: function () {
    let params = {
      wyqyId: wyqyId,
    };
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwyxyxx/wyqyinfo",
    });
  },

  //物业人员
  wyryquerylist: function (params) {
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwyxyxx/wyryquerylist",
    });
  },
  //加扣分记录
  jkfjlquerylist: function (params) {
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwyxyxx/jkfjlquerylist",
    });
  },
  // 获取报事报修指南 、 报事报修&投诉流程
  getInfo: function (params) {
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwygkgs/getInfo",
    });
  },
  // 物业概况
  wygk: function () {
    
    let params = {
      wyqyId: wyqyId
    }
    return request({
      method: "get",
      params,
      url: `middlescreen/api/zhwyxyxx/wygk`,
    });
  },
};

export default api;
